import { useUserStore } from '@modules/user/stores/user.store' /**

 * Reads lastUsedWorkspaceId from the current user's regional identity in the user store.
 */
export function getLastUsedWorkspaceIdFromUserStore(): string | null {
  return useUserStore.getState().currentUser?.regionalIdentity?.lastUsedWorkspaceId ?? null
}
